import React from 'react'
import SimpleBanner from '../../components/common/SimpleBanner'
import ContactSection from '../../components/User/Home/ContactSection'
import Contactmapsection from '../../components/User/Contact/Contactmapsection';

const Contact = () => {
  return (
    <div>
      <SimpleBanner title='Contact Us' subheading='Home > Contact Us' />
      <ContactSection/>
      <Contactmapsection/>
    </div>
  )
}

export default Contact
